import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Nav, Card, Table, Dropdown, Pagination } from '@themesberg/react-bootstrap';

import { studentReducerTypes, storeTypes } from 'types';
import { useSelector } from 'react-redux';
import { firstLetterCaps, simpleEncrypt } from 'utils/helpers';
import { faEdit, faEye } from '@fortawesome/free-solid-svg-icons';
import { useHistory } from 'react-router-dom';

export const StudentTables = ({ dispatchStudent, studentEdit }: { dispatchStudent: any; studentEdit: any }) => {
    const history = useHistory();
    const { studentDataState } = useSelector((state: storeTypes.IStore) => state);
    const { data, total, current_page, last_page, to, isLoading } = studentDataState;

    // eslint-disable-next-line no-shadow
    const TableRow = ({ data, index }: { data: studentReducerTypes.IStudent; index: number }) => {
        return (
            <tr>
                <td>
                    <span className="fw-normal">{index + 1}</span>
                </td>

                <td>
                    <span className="fw-normal">
                        {firstLetterCaps(data?.name)}
                        <br />
                        {data?.email}
                    </span>
                </td>
                <td>
                    <span className="fw-normal">{data?.mobileNumber}</span>
                </td>

                <td>
                    <span className="fw-normal">{data?.collegeName}</span>
                </td>
                <td>
                    <span className="fw-normal">{data?.department}</span>
                </td>

                <td>
                    <Dropdown.Item onClick={() => history.push(`/students/${simpleEncrypt(data?.id)}/view`)}>
                        <FontAwesomeIcon icon={faEye} className="me-2" /> View Details
                    </Dropdown.Item>

                    <Dropdown.Item onClick={() => studentEdit(data)}>
                        <FontAwesomeIcon icon={faEdit} className="me-2" /> Edit
                    </Dropdown.Item>
                    {/* <Dropdown as={ButtonGroup}>
            <Dropdown.Toggle as={Button} split variant="link" className="text-dark m-0 p-0">
              <span className="icon icon-sm">
                <FontAwesomeIcon icon={faEllipsisH} className="icon-dark" />
              </span>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item>
                <FontAwesomeIcon icon={faEye} className="me-2" /> View Details
              </Dropdown.Item>
              <Dropdown.Item>
                <FontAwesomeIcon icon={faEdit} className="me-2" /> Edit
              </Dropdown.Item>
              <Dropdown.Item className="text-danger">
                <FontAwesomeIcon icon={faTrashAlt} className="me-2" /> Remove
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown> */}
                </td>
            </tr>
        );
    };

    return (
        <Card border="light" className="table-wrapper table-responsive shadow-sm">
            <Card.Body className="pt-0">
                <Table hover className="user-table align-items-center">
                    <thead>
                        <tr>
                            <th className="border-bottom">#</th>
                            <th className="border-bottom">Name</th>
                            <th className="border-bottom">Mobile Number</th>
                            <th className="border-bottom">College</th>
                            <th className="border-bottom">Department</th>
                            <th className="border-bottom">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading && (
                            <tr>
                                <td align="center" colSpan={7}>
                                    <div className="spinner-border" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </td>
                            </tr>
                        )}

                        {!isLoading &&
                            data.map((studentData: studentReducerTypes.IStudent, index: number) => {
                                return (
                                    <TableRow data={studentData} index={index} key={`transaction-${studentData.id}`} />
                                );
                            })}
                    </tbody>
                </Table>
                <Card.Footer className="px-3 border-0 d-lg-flex align-items-center justify-content-between">
                    <Nav>
                        <Pagination className="mb-2 mb-lg-0">
                            <Pagination.Prev
                                onClick={() => dispatchStudent(current_page - 1, '')}
                                disabled={current_page === 1}
                            >
                                Previous
                            </Pagination.Prev>

                            {new Array(last_page).fill(null).map((p, i) => {
                                return (
                                    <Pagination.Item
                                        active={current_page === i + 1}
                                        onClick={() => dispatchStudent(i + 1, '')}
                                    >
                                        {i + 1}
                                    </Pagination.Item>
                                );
                            })}

                            <Pagination.Next
                                onClick={() => dispatchStudent(current_page + 1, '')}
                                disabled={current_page === last_page}
                            >
                                Next
                            </Pagination.Next>
                        </Pagination>
                    </Nav>
                    <small className="fw-bold">
                        Showing <b>{to}</b> out of <b>{total}</b> entries
                    </small>
                </Card.Footer>
            </Card.Body>
        </Card>
    );
};
